
<template>
<div id="catalogos_figuras_transporte">
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
  </div>
  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col xs="12">
        <base-material-card color="primary" icon="mdi-card-account-details-outline" title="Administrar Figuras Transporte" class="elevation-1 px-5 py-3">
          <v-card-actions>
            <v-spacer />

            <v-btn fab dark x-small color="primary" slot="activator" @click.native="agregar" title="Agregar Registro" v-tippy>
              <v-icon dark>add</v-icon>
            </v-btn>
          </v-card-actions>
          <v-card-text>
            <div id="datagrid">
              <v-client-table ref="vuetable" :data="items" :columns="columns" :options="options" class="elevation-2 pa-2">
                <template slot="noResults">
                  <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                </template>
                <template slot="actions" slot-scope="props">
               <v-btn x-small fab dark color="success" @click.native="editar(props.row.uuid)" title="Editar Registro" v-tippy>
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn x-small fab dark color="pink" @click.native="eliminar(props.row.uuid)" title="Eliminar Registro" v-tippy>
                      <v-icon>delete</v-icon>
                    </v-btn>
                </template>
              </v-client-table>
            </div>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
  <v-dialog v-model="modal" max-width="50%">
    <v-card>
      <v-card-title>
        <span class="headline">{{ tituloModal }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-form ref="form">
             
                <v-row>
                  <v-col sm="8" md="8" lg="8">
                    <v-text-field v-model="model.nombre" label="Nombre" :rules="[this.$rules.required]" maxlength="255"></v-text-field>
                  </v-col>
                  <v-col sm="4" md="4" lg="4">
                    <v-text-field v-model="model.rfc" label="RFC" :rules="[this.$rules.required, valida_unico]" maxlength="100"></v-text-field>
                  </v-col>                  
                </v-row>                       
                  <v-row>
                    <v-col sm="6" md="6" lg="6">
                      <v-text-field v-model="model.no_licencia" label="No. Licencia" :rules="[this.$rules.required]" maxlength="100"></v-text-field>
                    </v-col>                    
                    <v-col sm="6" md="6" lg="6">
                      <v-text-field v-model="model.telefono" label="Teléfono" :rules="[this.$rules.required]" maxlength="100"></v-text-field>
                    </v-col>                    
                  </v-row>  
                  <v-row>
                    <v-col>
                      <v-autocomplete v-model="model.clave_figura" label="Clave Figura" :rules="[this.$rules.required]" :items="clavesfiguras" 
                      :hide-no-data="true" :item-text="getNombreClave" item-value="clave"></v-autocomplete>
                    </v-col>
                  </v-row>    
                   <v-row>                    
                    <v-col sm="4" md="4" lg="4">
                      <v-switch v-model="model.activo" :label="model.activo" true-value="Activo" false-value="Inactivo"></v-switch>
                    </v-col>                    
                  </v-row>                      

          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="default" small @click="modal=false">
          <v-icon small>mdi-cancel</v-icon> Cancelar
        </v-btn>
        <v-btn color="success" small @click="guardar">
          <v-icon small>mdi-check-circle-outline</v-icon> Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>



<script>
export default {
  name: "DashboardDataTables",
  created: function() {
    this.URL = this.$hostname + "carta_porte/catalogos/";
    this.URL_SAT = this.$hostname + "carta_porte/catalogos_sat/";
    this.model = this.clean_model();
    this.cargarClavesFiguras();
    this.cargar();   
  },
  computed: {
    tituloModal() {
      return this.updateModel === false ? "Nueva Figura Transporte" : "Editar Figura Transporte";
    },
  },
  data: () => ({
    URL:"",
    URL_SAT:"",
    clavesfiguras: [],
    tabla: "figuras_transporte",
    modal: false,
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home",
      },
      {
        text: "Figuras Transporte",
        disabled: true,
        href: "",
      },
    ],
    model: {},
    updateModel: false,
    columns: ["rfc", "nombre","no_licencia","clave_figura","telefono", "actions"],
    options: {
      filterable: true,
      headings: {
        rfc: "RFC",
        nombre: "Nombre",
        no_licencia: "No. Licencia",
        clave_figura:"Clave Figura",
        telefono: "Teléfono",
        actions: "Operaciones"
      }
    },
    items: [],
    search: undefined,    
  }),
  methods: {
    getNombreClave: function(row){
      return row.clave+" - "+row.descripcion;
    },
    cargarClavesFiguras: function(){        
        var self = this;
        this.$axios.post(this.URL_SAT + "list_sat_figuras_transporte/")
          .then(res => {
              if (typeof res.data !== "undefined") {
                  self.clavesfiguras = res.data.sort(function(a, b){
                      if (a.clave_figura > b.clave_figura) {
                          return 1;
                      }
                      if (a.clave_figura < b.clave_figura) {
                          return -1;
                      }
                      return 0;
                  });
              }
          })
          .catch(err => {                        
              this.$swal({
                  type: "error",
                  title: "Error",
                  text: "Ocurrió un error al obtener los registros de claves de figuras.",
                  footer: "",
              });
              console.log(err);
          }); 
        
    },
    cargar: function() {
      this.$root.$dialogLoader.show("Espere un momento por favor..");        
        
      var params = {
        uuid_empresa: this.model.uuid_empresa
      };
      
      var self = this;
      this.$axios.post(this.URL + "list_figuras_transporte/", params)
          .then(res => {
              if (typeof res.data !== "undefined") {
                  self.items = res.data;                  
              }
          })
          .catch(err => {                        
              this.$swal({
                  type: "error",
                  title: "Error",
                  text: "Ocurrió un error al obtener los registros.",
                  footer: "",
              });
              console.log(err);
          }).then(()=>{
              this.$root.$dialogLoader.hide();
          });      
    },
    validaEntero: function(value){ 
        const pattern = /^[\d]*$/;            
        if (value!=null && !pattern.test(value) ){
            return "Solo se acepta números";
        } 
        else 
            return true;            
    },
    valida_unico: function(rfc) {      
        let records = this.items.filter(x => x.rfc.toString().toLowerCase() == rfc.toString().toLowerCase());
        //console.log(records);
        if (records.length > 0 && this.updateModel === false) {
          return "El RFC ya existe";
        }
        return true;     
    },
    agregar: function() {
      this.model = this.clean_model();
      this.updateModel = false;
      this.modal = true;
      
    },
    editar: function(id) {
      this.$root.$dialogLoader.show("Espere un momento por favor..");
      var self = this;
      this.model = this.clean_model();
      var params = {
          uuid: id, 
          uuid_empresa: this.model.uuid_empresa
      };
      this.$axios.post(this.URL + "list_figuras_transporte/", params)
          .then(res => {
              if (typeof res.data !== "undefined") {
                  self.model = res.data[0];            
                  self.modal = true;
                  self.updateModel = true;                  
              }
          })
          .catch(err => {                        
              this.$swal({
                  type: "error",
                  title: "Error",
                  text: "Ocurrió un error al obtener el registro.",
                  footer: "",
              });
              console.log(err);
          }).then(()=>{
              self.$root.$dialogLoader.hide();
          });        
    },

    eliminar: function (id) {
        var self = this;
        self.$swal({
            type: "info",
            title: "Cuidado",
            text: "¿Está seguro de eliminar el registro?",
            footer: "",
            showCancelButton: true,
            cancelButtonColor: "#d33",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result.value) {
                this.$root.$dialogLoader.show("Espere un momento por favor..");
                var data = {
                    uuid: id,                        
                };
                this.$axios.post(this.URL + "delete_figuras_transporte/", data)
                    .then(res => {
                        self.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "El registro se eliminó correctamente.",
                            footer: "",
                        });
                        self.cargar();
                    })
                    .catch(err => {
                        this.$swal({
                            type: "error",
                            title: "Error",
                            text: "Ocurrió un error al eliminar el registro.",
                            footer: "",
                        });
                        console.log(err);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                    });                
            }
        });

    },
    guardar: function() {
      if (!this.$refs.form.validate()) {
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show("Espere un momento por favor..");

        var url = this.URL + "create_figuras_transporte/";
        if (this.updateModel === false) 
          this.model.uuid = this.$uuid.v4();
        else
          url = this.URL + "update_figuras_transporte/";
        
        var self = this;
        this.$axios.post(url, this.model)
            .then(res => {                    
                self.$swal({
                    type: "success",
                    title: "¡Operación Exitosa!",
                    text: "El registro se guardó correctamente.",
                    footer: "",
                });
                self.modal = false;                                          
            })
            .catch(err => {
                console.log(err);
                self.$swal({
                    type: "error",
                    title: "Error",
                    text: "Ocurrió un error al guardar el registro.",
                    footer: "",
                });                        
            }).then(() => {                        
                self.add_registro = false;
                self.cargar();
                this.$root.$dialogLoader.hide();
            });          

      }
    },
    clean_model: function() {
      return {
        uuid: "",
        uuid_empresa: this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("uuid_empresa")) ),
        rfc: "",
        nombre: "",
        no_licencia:"",
        clave_figura:"",
        telefono:"",    
        activo:"Activo" 
      };
    }
  },
};
</script>
